/**
 * Guardio Protection for Chrome — security / anti-scam extension
 *
 * Exposes a single WAR group to every origin with no `use_dynamic_url`, holding six
 * static paths: `assets/installed.json`, `injected.bundle.js`, `uiInjected.bundle.js`,
 * `permissionProxy.bundle.js`, `permissionProxyDisabled.bundle.js` and `frame.html`.
 * None is build-hashed, so all are fetchable from any page at a fixed URL.
 *
 * `assets/installed.json` is the most distinctive — a vendor-named marker file — and,
 * with the extension ID in the URL, a successful fetch is conclusive.
 *
 * Manifest verified against version 26.4.30.3118.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'gjfpmkejnolcfklaaddjnckanhhgegla';

export const guardioProtection: ExtensionDefinition = {
  id: ID,
  name: 'Guardio Protection for Chrome',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 600_000,
  notes:
    'Six static WAR exposed to every origin, no dynamic URL. The installed.json marker ' +
    'is conclusive; two bundle paths corroborate.',
  signals: [
    {
      id: 'war-installed-json',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/installed.json — a vendor-named marker file exposed to every ' +
        'origin at a fixed URL.',
      weight: 1,
      run: () => probeFetch(ID, 'assets/installed.json'),
    },
    {
      id: 'war-injected-bundle',
      kind: 'web-accessible-resource',
      description:
        'Fetch injected.bundle.js — a stable (non-hashed) webpack bundle, a second path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'injected.bundle.js'),
    },
    {
      id: 'war-frame-html',
      kind: 'web-accessible-resource',
      description: 'Fetch frame.html — an independent third path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'frame.html'),
    },
  ],
};
